import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { Image } from "react-bootstrap";
import fire from "../../../../services/fire";
import AppGlobalContext from "../../../../AppGlobalContext";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";
import StarIcon from "@material-ui/icons/Star";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import WeekendIcon from "@material-ui/icons/Weekend";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import FacebookIcon from "@material-ui/icons/Facebook";
import FilterNoneIcon from "@material-ui/icons/FilterNone";
import {
  getShortMonthDateObj,
  getShortDay,
  getMassTimeAMPM,
} from "../../../../utils/utils";
import { displayBookingDisabledMessage } from "../../utils/eventHelpers";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "../../assets/css/event-card.css";
import EventInterestButton from "./EventInterestButton";
import htmlToDraft from "html-to-draftjs";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState } from "draft-js";

const EventCardFull = ({
  eventDetails = {
    eventName: "",
    eventOrgName: "",
    eventDescription: "",
    eventTags: [],
    eventCost: 0,
    eventImage: "",
    eventSchedules: [
      {
        startDate: "",
        endDate: "",
        eventLocation: "",
        eventVenue: "",
        capacity: "",
        hasReserve: false,
        reserveCapacity: 0,
        bookingStartDate: "",
        availableSlots: [],
        isWalkIn: false,
      },
    ],
  },
  isPreview = false,
  eventPageState = {
    isLoading: true,
    isNotFound: true,
    eventDetails: {},
    isLoginModalOpen: false,
    isLoginSuccess: false,
    buttonClicked: "",
    selectedSchedule: "",
  },
  bookEvent = (eventId) => {},

  setInterest = (eventId, cb = () => {}) => {},
  setEventPageState = () => {},
}) => {
  const {
    eventName,
    eventOrgName,
    eventDescription,
    eventCost,
    eventTags,
    eventImage,
    eventSchedules,
  } = eventDetails;
  const [eventImageURL, setEventImageURL] = useState(false);
  const [interestCount, setInterestCount] = useState(-1);
  const [userBookings, setUserBookings] = useState([]);
  const [copyText, setCopyText] = useState("Copy Link");
  const { user } = useContext(AppGlobalContext);
  const { id } = useParams();
  document.title = `myCatholicSG - ${eventName}`;
  const blocksFromHtml = htmlToDraft(eventDescription);
  const contentState = ContentState.createFromBlockArray(
    blocksFromHtml.contentBlocks
  );
  const editorState = EditorState.createWithContent(contentState);

  useEffect(() => {
    // Get Event Image
    if (eventImage !== "") {
      fire
        .storage()
        .ref(eventImage)
        .getDownloadURL()
        .then((url) => {
          setEventImageURL(url);
        });
    }
  }, [eventImage]);

  useEffect(() => {
    // Get Interest Count
    if (!isPreview) {
      fire
        .firestore()
        .collection("eventinterests")
        .where("parentEventId", "==", id)
        .get()
        .then((snapshot) => {
          if (!snapshot.empty) {
            setInterestCount(snapshot.docs.length);
          }
        });
      if (user?.userid) {
        fire
          .firestore()
          .collection("eventhubbookings")
          .where("userId", "==", user.userid)
          .get()
          .then((userBookingSnapshot) => {
            let newUserBookings = [];
            if (!userBookingSnapshot.empty) {
              userBookingSnapshot.docs.forEach((doc) => {
                newUserBookings.push(doc.data());
              });
              setUserBookings(newUserBookings);
            }
          });
      }
    }
    // Run effect once on component mount, recheck if deps updated
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const triggerCopy = () => {
    setCopyText("  Copied!  ");
    setTimeout(() => {
      setCopyText("Copy Link");
    }, 1000);
  };

  const displayEventTime = (startDate, endDate) => {
    const startDay = startDate.getDate();
    const endDay = endDate.getDate();
    const startMonth = startDate.getMonth();
    const endMonth = endDate.getMonth();
    const startYear = startDate.getFullYear();
    const endYear = endDate.getFullYear();

    if (endDay > startDay || endMonth > startMonth || endYear > startYear) {
      // Event extends beyond single day
      const startDateStr =
        getShortDay(startDate) +
        ", " +
        startDay +
        " " +
        getShortMonthDateObj(startDate) +
        ", " +
        getMassTimeAMPM(startDate) +
        " -";
      const endDateStr =
        getShortDay(endDate) +
        ", " +
        endDay +
        " " +
        getShortMonthDateObj(endDate) +
        ", " +
        getMassTimeAMPM(endDate);

      return (
        <div className="d-flex">
          <div className="d-flex flex-column justify-content-center mr-4">
            <CalendarTodayIcon className="event-card-detail__icons" />
          </div>
          <div className="d-flex flex-column">
            <div className="font-weight-bold">{startDateStr}</div>
            <div className="font-weight-bold">{endDateStr}</div>
          </div>
        </div>
      );
    } else {
      const startDateStr =
        getShortDay(startDate) +
        ", " +
        startDay +
        " " +
        getShortMonthDateObj(startDate) +
        " " +
        endYear;
      const startEndTimeStr =
        getMassTimeAMPM(startDate) + " - " + getMassTimeAMPM(endDate);
      return (
        <>
          <div className="d-flex">
            <div className="d-flex flex-column justify-content-center mr-4">
              <CalendarTodayIcon className="event-card-detail__icons" />
            </div>
            <div className="font-weight-bold">{startDateStr}</div>
          </div>
          <div className="d-flex">
            <div className="d-flex flex-column justify-content-center mr-4">
              <AccessTimeIcon className="event-card-detail__icons" />
            </div>
            <div className="font-weight-bold">{startEndTimeStr}</div>
          </div>
        </>
      );
    }
  };

  const hasUserBooked = (schedule) => {
    if (user?.userid && userBookings.length > 0) {
      for (let booking of userBookings) {
        if (
          booking.eventId === schedule.eventId &&
          (!booking.hasOwnProperty("isDraft") || !booking.isDraft)
        ) {
          return true;
        }
      }
    }
    return false;
  };

  const displaySchedules = () => {
    const elements = [];
    eventSchedules.forEach((schedule, i) => {
      const bookingDisabledMsg = displayBookingDisabledMessage(
        schedule,
        isPreview,
        user
      );

      if (i > 0) {
        elements.push(
          <div className="mt-4" key={i}>
            <hr />
            {displayEventTime(schedule.startDate, schedule.endDate)}
            <div className="d-flex">
              <div className="d-flex flex-column justify-content-center mr-4">
                <LocationOnIcon className="event-card-detail__icons" />
              </div>
              <div>{schedule.eventLocation}</div>
            </div>
            <div className="d-flex">
              <div className="d-flex flex-column justify-content-center mr-4">
                <MeetingRoomIcon className="event-card-detail__icons" />
              </div>
              <div>{schedule.eventVenue}</div>
            </div>
            {schedule.eventId !== "NbBxLHZLwloUa20EFX05" && (
              <div className="d-flex mb-3">
                <div className="d-flex flex-column justify-content-center mr-4">
                  <WeekendIcon className="event-card-detail__icons" />
                </div>
                <div>
                  {isPreview ? schedule.capacity : schedule.available} Seats
                  Available
                </div>
              </div>
            )}
            <div className="d-flex justify-content-end">
              <EventInterestButton
                eventId={schedule.eventId}
                isPreview={isPreview}
                setInterest={setInterest}
                eventPageState={eventPageState}
                setEventPageState={setEventPageState}
              />
              {schedule.isWalkIn ? (
                <div className="event-card-book__btn--disabled">
                  Walk-Ins Only
                </div>
              ) : hasUserBooked(schedule) ? (
                <div className="d-flex text-center py-1 px-2">
                  <CheckCircleIcon
                    className="mr-1 mt-1"
                    style={{ color: "green" }}
                  />
                  Booked!
                </div>
              ) : (
                <div
                  className={
                    bookingDisabledMsg &&
                    bookingDisabledMsg !== "You need to be logged in to book"
                      ? "event-card-book__btn--disabled"
                      : "event-card-book__btn"
                  }
                  onClick={() => {
                    if (id === "0UclYzAObSzUvONTi1Qc") {
                      console.log("here");
                      window.open("https://tinyurl.com/HCLentRetreat2025");
                    } else {
                      if (!isPreview && !bookingDisabledMsg) {
                        bookEvent(schedule.eventId);
                      } else if (
                        bookingDisabledMsg !==
                        "You need to be logged in to book"
                      ) {
                      } else {
                        setEventPageState({
                          ...eventPageState,
                          isLoginModalOpen: true,
                          buttonClicked: "booking",
                          selectedSchedule: schedule.eventId,
                        });
                      }
                    }
                  }}
                >
                  Book Event
                </div>
              )}
            </div>
            {!schedule.isWalkIn && !hasUserBooked() && bookingDisabledMsg && (
              <div className="d-flex justify-content-end mt-1">
                {bookingDisabledMsg}
              </div>
            )}
          </div>
        );
      } else {
        elements.push(
          <div key={i}>
            {displayEventTime(schedule.startDate, schedule.endDate)}
            <div className="d-flex">
              <div className="d-flex flex-column justify-content-center mr-4">
                <LocationOnIcon className="event-card-detail__icons" />
              </div>
              <div>{schedule.eventLocation}</div>
            </div>
            <div className="d-flex">
              <div className="d-flex flex-column justify-content-center mr-4">
                <MeetingRoomIcon className="event-card-detail__icons" />
              </div>
              <div>{schedule.eventVenue}</div>
            </div>
            {schedule.eventId !== "NbBxLHZLwloUa20EFX05" && (
              <div className="d-flex mb-3">
                <div className="d-flex flex-column justify-content-center mr-4">
                  <WeekendIcon className="event-card-detail__icons" />
                </div>
                <div>
                  {isPreview ? schedule.capacity : schedule.available} Seats
                  Available
                </div>
              </div>
            )}
            <div className="d-flex justify-content-end">
              <EventInterestButton
                eventId={schedule.eventId}
                isPreview={isPreview}
                setInterest={setInterest}
                eventPageState={eventPageState}
                setEventPageState={setEventPageState}
              />
              {schedule.isWalkIn ? (
                <div className="event-card-book__btn--disabled">
                  Walk-Ins Only
                </div>
              ) : hasUserBooked(schedule) ? (
                <div className="d-flex text-center py-1 px-2">
                  <CheckCircleIcon
                    className="mr-1 mt-1"
                    style={{ color: "green" }}
                  />
                  Booked!
                </div>
              ) : (
                <div
                  className={
                    bookingDisabledMsg &&
                    bookingDisabledMsg !== "You need to be logged in to book"
                      ? "event-card-book__btn--disabled"
                      : "event-card-book__btn"
                  }
                  onClick={() => {
                    if (id === "0UclYzAObSzUvONTi1Qc") {
                      console.log("here");
                      window.open("https://tinyurl.com/HCLentRetreat2025");
                    } else {
                      if (!isPreview && !bookingDisabledMsg) {
                        bookEvent(schedule.eventId);
                      } else if (
                        bookingDisabledMsg !==
                        "You need to be logged in to book"
                      ) {
                      } else {
                        setEventPageState({
                          ...eventPageState,
                          isLoginModalOpen: true,
                          buttonClicked: "booking",
                          selectedSchedule: schedule.eventId,
                        });
                      }
                    }
                  }}
                >
                  Book Event
                </div>
              )}
            </div>
            {!schedule.isWalkIn && bookingDisabledMsg && (
              <div className="d-flex justify-content-end mt-1">
                {bookingDisabledMsg}
              </div>
            )}
          </div>
        );
      }
    });
    return elements;
  };

  const displayTags = () => {
    const elements = [];
    eventTags.forEach((tag, i) => {
      if (i > 0) {
        elements.push(
          <div className="event-card-tags__container mb-2 ml-3" key={i}>
            {tag}
          </div>
        );
      } else {
        elements.push(
          <div className="event-card-tags__container mb-2" key={i}>
            {tag}
          </div>
        );
      }
    });

    return elements;
  };

  return (
    <>
      <div>
        {eventImage !== "" && eventImageURL && (
          <div className="event-card-image__container mb-3">
            <Image className="event-card__img" src={eventImageURL} />
          </div>
        )}
        <div className="event-card-detail__title">{eventName}</div>
        <div className="event-card-detail__title-desc mb-4">
          Organized by {eventOrgName}
        </div>
      </div>
      <div className="event-card-detail__container">
        <div className="row">
          <div className="col-md">
            <div className="event-card-detail__mini-container mb-3">
              <div className="event-card-detail__subtitle">What it's about</div>
              <div>
                <Editor
                  editorStyle={{
                    height: "fit-content",
                    background: "white",
                  }}
                  editorState={editorState}
                  toolbarHidden={true}
                  readOnly={true}
                />
              </div>
            </div>
            <div className="event-card-detail__mini-container mb-3">
              <div className="event-card-detail__subtitle">Tags</div>
              <div className="d-flex flex-wrap">{displayTags()}</div>
            </div>
          </div>
          <div className="col-md">
            <div className="event-card-detail__mini-container mb-3">
              <div className="event-card-detail__subtitle">Event Schedule</div>
              {displaySchedules()}
            </div>
            <div className="event-card-detail__mini-container mb-4">
              <div className="event-card-detail__subtitle">
                Other Information
              </div>
              {(interestCount > 0 || isPreview) && (
                <div className="d-flex">
                  <div className="d-flex flex-column justify-content-center mr-4">
                    <StarIcon className="event-card-detail__icons" />
                  </div>
                  <div>
                    {isPreview ? "__" : interestCount + " "}
                    Interested
                  </div>
                </div>
              )}
              {/* Added special provision for CHC Lenten Retreat 2025 */}
              {id !== "0UclYzAObSzUvONTi1Qc" && (
                <div className="d-flex mb-3">
                  <div className="d-flex flex-column justify-content-center mr-4">
                    <LocalAtmIcon className="event-card-detail__icons" />
                  </div>
                  <div>{eventCost > 0 ? `$ ${eventCost}` : "Free"}</div>
                </div>
              )}
              {id === "0UclYzAObSzUvONTi1Qc" && (
                <div className="d-flex mb-3">
                  <div className="d-flex flex-column justify-content-center mr-4">
                    <LocalAtmIcon className="event-card-detail__icons" />
                  </div>
                  <div>$40</div>
                </div>
              )}
            </div>
            <div className="event-card-detail__mini-container ">
              <div className="event-card-detail__subtitle">Share</div>
              <div className="d-flex justify-content-around px-4">
                <div
                  className="btn"
                  onClick={() =>
                    !isPreview
                      ? window.open(
                          `whatsapp://send?text=${
                            `https://` + window.location.host + `/link/${id}`
                          }`
                        )
                      : {}
                  }
                >
                  <WhatsAppIcon
                    style={{ fontSize: "40px", color: "#6c757d" }}
                  />
                  <div className="mt-1">WhatsApp</div>
                </div>
                <div
                  className="btn"
                  onClick={() =>
                    !isPreview
                      ? window.open(
                          `https://www.facebook.com/dialog/share?app_id=335719721942948&display=popup&href=${
                            `https://` + window.location.host + `/link/${id}`
                          }&redirect_uri=${
                            `https://` + window.location.host + `/link/${id}`
                          }`
                        )
                      : {}
                  }
                >
                  <FacebookIcon
                    style={{ fontSize: "40px", color: "#6c757d" }}
                  />
                  <div className="mt-1">Facebook</div>
                </div>
                <div
                  className="btn"
                  onClick={() => {
                    if (!isPreview) {
                      navigator.clipboard.writeText(
                        `https://` + window.location.host + `/link/${id}`
                      );
                      triggerCopy();
                    }
                  }}
                >
                  <FilterNoneIcon
                    style={{ fontSize: "40px", color: "#6c757d" }}
                  />
                  <div className="mt-1">{copyText}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EventCardFull;
